import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpParams, HttpRequest} from '@angular/common/http';

import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {ActivatedRoute, Router} from "@angular/router";

@Injectable(
    {providedIn: 'root'}
)
export class ApiKeyInterceptor implements HttpInterceptor {
    constructor(private router: Router, private route: ActivatedRoute) {
    }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let params = req.params;

    let apikey = this.route.snapshot.queryParamMap.get('apikey');
    if (!apikey) {
      apikey = this.router.getCurrentNavigation()?.initialUrl?.queryParams['apikey']
    }
    if (apikey) {
       params = params.append('apikey', apikey);
    }

    const optionsReq = req.clone({
      params: params
    });

    return next.handle(optionsReq);
  }
}
